import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AddToCompanyState = {
    open: false,
    company: {
        id: null,
        name: null,
        isAdmin: false,
    },
    successfulSend: false,
};

export const addToCompanySlice = createSlice({
    name: 'add-to-company-dialog',
    initialState,
    reducers: {
        setDialogOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setCompany: (state, action: PayloadAction<CompanyProps>) => {
            state.company = action.payload;
        },
        setSuccessfulSend: (state, action: PayloadAction<boolean>) => {
            state.successfulSend = action.payload;
        },
        resetStates: (state, action: PayloadAction<{isSuccess: boolean}>) => {
            state.company = {
                id: null,
                name: null,
                isAdmin: false,
            };
            state.open = false;
            state.successfulSend = action.payload.isSuccess;
        },
    },
});

export interface AddToCompanyState {
    open: boolean;
    company: CompanyProps;
    successfulSend: boolean;
}

type CompanyProps = {
    id: string;
    name: string;
    isAdmin: boolean;
};

export const addToCompanyAction = addToCompanySlice.actions;

export default addToCompanySlice.reducer;
